import { withNaming } from "@bem-react/classname";
import { useCallback } from "react";

/**
 * Возвращает функцию получения класса по БЭМ
 * @param block{String} - блок
 * @param elem{String=} - элемент
 * @param mod{Object=} - модификаторы
 * @returns {string}
 * @example
 * // Рекомендуется использовать хук useCN.
 * import { getClassString } from "@delement/ui/utils";
 * const App = () => {\
 *   const myClass = getClassString("class", "el", { isMod: true }); // class__el--isMod
 *   return <div className={myClass}></div>
 * }
 */
export const getClassString = (block = "", elem = "", mod: {} | null = {}) => withNaming({
  n: "",
  e: "__",
  m: "--",
  v: "-",
})(block, elem)(mod);

/**
 * Добавляет функцию генерации класса для элементов
 * @param baseClass{String=} - базовый класс (блок)
 * @returns {{ getCN: Function }}
 * @example
 * import { useCN } from "@delement/ui/utils/react/useCN";
 *
 * const App = () => {
 *  const { getCN } = useCN("myAppBaseClass");
 *  return (
 *     <div className={getCN()}>
 *       <ul className={getCN("list", {}, [ "isResetList" ])}>
 *        <li className={getCN("item", { isMyItem: true })}></li>
 *       </ul>
 *       <h1 className={getCN("title h2")}>Title with two blocks</h1>
 *     </div>
 *   )
 * }
 */
export const useCN = (baseClass = "") => {

  const getCN = useCallback((elem = "", mod: {} | null = {}, utilClasses: string[] = []) => {
    if (typeof baseClass === "string" && baseClass.length) {
      const cn = getClassString(baseClass, elem, mod);
      return utilClasses.length ? [ cn, ...utilClasses ].join(" ") : cn;
    } else {
      return "";
    }
  }, []);

  return { getCN };

};
